import React from 'react'
import { Chip, FormControl, InputLabel, MenuItem } from '@material-ui/core'
import { Select } from 'redux-form-material-ui-adapter'
import { Field } from 'redux-form'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      // width: 250,
    },
  },
};

export default class SelectMultipleReduxField extends React.Component {
  valueToName(value) {
    let found = this.props.options.find((element) => element.value === value);
    if (found) {
      return found.name;
    } else {
      return '';
    }
  }

  render() {
    let {options, label, fullWidth, ...other} = this.props;

    return (
      <FormControl
        fullWidth={fullWidth}
        // className={classes.formControl}
      >
        <InputLabel htmlFor="select-multiple-checkbox">{label}</InputLabel>
        <Field {...other} component={Select} multiple
          // onChange={this.handleChange}
               format={value => Array.isArray(value) ? value : []}
               renderValue={selected => (
                 <div
                   // className={classes.chips}
                 >
                   {selected.map(value => <Chip key={value} label={this.valueToName(value)}
                     /* className={classes.chip} */
                   />)}
                 </div>
               )}
               MenuProps={MenuProps}
        >

          {options.map(({name, value}) => {
            return <MenuItem key={value} value={value}>
              {name}
            </MenuItem>
          })}
        </Field>
      </FormControl>
    )
  }
};
